import {
  OrderProductError,
  ValidateOrderProductsOutput,
} from '../../../../services/modules/order-product/order-product.types';
import { getOrderProductUniqueIdentifier } from '../../../../utils/getOrderProductUniqueIdentifier';
import { OrderProduct } from '../../../orders/products/orderProducts.types';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  OrderProductWithError,
} from '../../domain/offlineOrder/rules/OfflineOrderRules.types';

export default class ValidateOrderProductsUtils {
  static formatOrderProductsErrors = (
    errors: OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS][],
  ): ValidateOrderProductsOutput => {
    const orderProductsWithErrors = new Map<string, OrderProductError[]>();
    const errorsWithQuantities = new Map<string, number>();

    const rulesWithError = errors.filter((output) => output.hasErrors);

    for (const rule of rulesWithError) {
      for (const product of rule.orderProductsWithError) {
        const key = this.getOrderProductKeyIds(product);

        if (!orderProductsWithErrors.has(key)) {
          orderProductsWithErrors.set(key, []);
        }

        orderProductsWithErrors.get(key)!.push({
          message: rule.error.messageCode,
          messageCode: rule.error.messageCode,
          extra: product.extra,
        });
      }

      const errorKey = rule.error.messageCode;
      errorsWithQuantities.set(
        errorKey,
        (errorsWithQuantities.get(errorKey) || 0) + rule.orderProductsWithError.length,
      );
    }

    return {
      orderProductsWithErrors: Object.fromEntries(orderProductsWithErrors),
      errorsWithQuantities: Object.fromEntries(errorsWithQuantities),
    };
  };

  private static getOrderProductKeyIds(product: OrderProductWithError) {
    return getOrderProductUniqueIdentifier({
      productColorId: product.productColorId,
      availability: product.availability,
      deliveryWindow: product.deliveryWindowId
        ? ({ id: product.deliveryWindowId } as OrderProduct['deliveryWindow'])
        : undefined,
    });
  }
}
